import { Heart } from 'lucide-react';
import { usePhotoLikeCounts } from '@/utils/photoLikes';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

/** Public like count shown on grid thumbnails (never on enlarged photos). Hidden at 0. */
export const PhotoLikeBadge = ({ count, className }: { count?: number; className?: string }) => {
  const { t } = useTranslation();
  if (!count) return null;
  return (
    <span
      aria-label={t('likes.count', { count })}
      className={cn(
        'pointer-events-none absolute bottom-1.5 right-1.5 inline-flex items-center gap-1 rounded-full bg-background/90 px-1.5 py-0.5 text-[11px] font-semibold leading-none text-primary tabular-nums shadow-sm backdrop-blur-sm',
        className,
      )}
    >
      <Heart className="h-3 w-3 fill-current" strokeWidth={2} aria-hidden />
      {count}
    </span>
  );
};

/** Render-prop wrapper so pages with early returns can use like counts without moving hooks. */
export const WithLikeCounts = ({ eventId, photoIds, children }: { eventId?: string; photoIds: (number | null)[]; children: (counts: Record<number, number>) => React.ReactNode }) => {
  const counts = usePhotoLikeCounts(eventId, photoIds);
  return <>{children(counts)}</>;
};
